import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '../../store/auth/auth.reducer';
import * as fromAuth from '../../store/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as fromRouting from "../../../core/store/routing";
import { SystemNotificationsService } from '@app/core/system-notifications/system-notifications.service';

@Component({
    selector: 'topo-external-link',
    templateUrl: './external-link.component.html',
    styleUrls: ['./external-link.component.scss'],
    standalone: false
})
export class ExternalLinkComponent implements OnInit, OnDestroy {
  code: string;
  target: string;
  destroy$ = new Subject<void>();
  errorMessage$: Observable<string>;
  error: boolean;
  errorMessage: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<State>,
    private spinnerService: NgxSpinnerService,
    private translateService: TranslateService) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete()
  }

  ngOnInit(): void {
    this.error = false;
    this.errorMessage$ = this.store.select(fromAuth.selectExternalLinkError);

    this.activatedRoute.queryParams.subscribe(params => {
      this.store.dispatch(fromAuth.setExternalLinkError({ err: null }));
      this.code = decodeURI(params['code']);
      this.store.dispatch(fromAuth.externalLinkAuthWorking({ isWorking: true }));
      this.store.dispatch(fromAuth.routeToExternalLink({ sharedCode: this.code }));
    });

    this.store.select(fromAuth.selectIsExternalLinkAuthWorking)
    .pipe(
      tap(isWorking => {
        isWorking ? this.spinnerService.show() : this.spinnerService.hide();
      }),
      takeUntil(this.destroy$)
    )
    .subscribe();

    this.errorMessage$
      .pipe(
        filter(err => !!err),
        tap(value => {
          this.spinnerService.hide();
          this.error = true;
          if (value == "IP_ADDRESS_IS_RESRICTED") {
            this.store.dispatch(
              fromRouting.go({
                routeData: { path: ['login/ip-restricted'] }
              })
            );
          }
          else {
            this.errorMessage = this.translateService.instant(`ERRORS.${value}`);
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
}
